export const rgbaHexToRgbHex = (targetHex: string, backgroundHex: string) => {
  if (targetHex?.length !== 9) return targetHex;

  const hexToRgb = (hex: string) => {
    const bigint = Number.parseInt(hex.slice(1, 7), 16);
    const red = (bigint >> 16) & 255;
    const green = (bigint >> 8) & 255;
    const blue = bigint & 255;
    return [red, green, blue];
  };

  const [red1, green1, blue1] = hexToRgb(targetHex);
  const [red2, green2, blue2] = hexToRgb(backgroundHex);

  const alpha = Number.parseInt(targetHex.slice(7), 16) / 255;

  const red = Math.round(red1 * alpha + red2 * (1 - alpha));
  const green = Math.round(green1 * alpha + green2 * (1 - alpha));
  const blue = Math.round(blue1 * alpha + blue2 * (1 - alpha));

  return `#${((1 << 24) + (red << 16) + (green << 8) + blue).toString(16).slice(1)}`;
};
